import axiosInstance from ".";

export const getNDA = () => {
  return axiosInstance.get("/nds");
};

export const addNDA = (data) => {
  return axiosInstance.post("/nds", data);
};

export const updateNDA = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/nds/${id}`, payload);
};
